import React, { useState } from 'react'
import Layout from '../../component/layout/Layout'
import { Tab } from '@headlessui/react'
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
export default function TermsAndCondition() {
    let [conditions] = useState([
        {
            //  title:"Welcome to LMIA.LTD.",
           description:`Welcome to LMIA.LTD. Before you sign up for an account, please carefully read and
           understand the following terms and conditions ("Terms"). By signing up for an account,
           you agree to be bound by these Terms.`
         },
        {
             title:"1. User Information Collection",
           description:`When you sign up for an account on our website, we
           collect the following information: first name, last name, country, province, city, and
           phone number. By signing up, you consent to the collection and use of this information
           as described herein.`
         },
        {
             title:"2. Non-Endorsement",
           description:` LMIA.LTD does not endorse any employer or employment
           opportunity listed in our database. We do not guarantee the accuracy, completeness, or
           reliability of the information provided. Users are solely responsible for their interactions
           with employers and any decisions made based on the information available on our
           website.`
         },
        {
             title:"3. No Warranty",
           description:` The information provided on our website is provided "as is" without any
           warranties, express or implied. LMIA.LTD makes no representations or warranties of
           any kind regarding the accuracy, reliability, or suitability of the information contained
           herein. We disclaim all warranties, including but not limited to, implied warranties of
           merchantability, fitness for a particular purpose, and non-infringement.
           `
         },
        {
             title:"4. Use of User Information",
           description:` By signing up for an account on our website, you consent to
           the collection, use, and storage of your personal information for marketing purposes.
           We may use your information to send you promotional emails, newsletters, or other communications regarding our services. You have the right to opt-out of receiving such
           communications at any time by contacting us or using the unsubscribe link provided in
           our emails. `
         },
        {
             title:"5. Governing Law",
           description:` These Terms and your use of our website are governed by the laws
           of the province of British Columbia and the applicable laws of Canada. Any dispute
           arising out of or relating to these Terms or your use of our website shall be subject to
           the exclusive jurisdiction of the courts located in British Columbia.
           `
         },
        {
             title:"6. Modification of Terms",
           description:`LMIA.LTD reserves the right to modify these Terms at any time
           without prior notice. Any changes to these Terms will be effective immediately upon
           posting on our website. It is your responsibility to review these Terms periodically for
           any updates or changes.`
         },
        {
             title:"7. Ownership and Operator",
           description:`LMIA.LTD is owned and operated by Watershed
           Immigration Corp.
           `
         },
        {
             title:"8.Contact Us",
           description:`If you have any questions or concerns regarding these Terms or our privacy practices, please contact us at info@watershedcorp.ca.
           `
         },
    ])
  return (
    <Layout>
    <div className="container px-2 md:px-20 m-auto py-4">
    <div className="relative">

     <div className="term-h1">
        <h1 className='bg-white inline relative'>Welcome to LMIA.LTD</h1>
     </div>
    </div>

    <div className="">
        <div className="py-3">
        {conditions.map((post, idx) => (
            <div className='pb-10' key={idx}>
                <div>
               {post.title ? <h1 className='text-xl font-bold'>{post.title}</h1> : null}
                <p className='font-normal '>{post.description}</p>
                </div>
            </div>
        ))}
    <p className='font-normal '>
    By signing up for an account on our website, you acknowledge that you have read,
understood, and agree to be bound by these Terms. If you do not agree to these Terms,
please do not sign up for an account or use our website.
      </p>
        </div>
  
    </div>
  </div>

    </Layout>
  )
}
